<template>
	<div class="ReductionField"
		:class="{ dense }"
	>
<!-- TODO: inline messages instead? -->
		<Alert style="margin-top:4em" v-model="errorTitle">{{ errorDetail }}</Alert>
		<Alert style="margin-top:4em" v-model="successTitle" type="success">{{ successDetail }}</Alert>

		<!-- TODO: SCR: serviceProviderOptions needs to come from the channelAssignments -->
		<OptionSelectField
			v-model:serviceProviderOptions="serviceProviderOptions"
			:clientOptions="clientOptions"
			v-model="model"
			:canAddNew="canAddNew"
			@show-add-option='addOptionStart'
			@focus="$emit('focus', $event)"
			:data-cy="dataCy"
			:error="error"
			:dense="dense"
			:disabled="disabled"
		>
			<template #append-item v-if="$slots['append-item']">
				<slot name="append-item" />
			</template>
		</OptionSelectField>
		<TicketCategoryDialog
			ref="ticketCategoryDialog"
			@confirm="onTicketCategoryConfirm"
			@cancel="onTicketCategoryCancel"
		/>
	</div>
</template>

<script>
import Common from '@/mixins/Common.vue'
import OptionSelectField from './OptionSelectField.vue'
import Alert from '@/components/common/Alert.vue'
import Loading from '@/mixins/Loading.vue'
import TicketCategoryDialog from '@/views/applications/settings/TicketCategoryDialog.vue'
import ChildErrorDispatcher from '@/views/applications/packageDesigner/ChildErrorDispatcher.vue'

export default {
	mixins: [ Common, Loading, ChildErrorDispatcher ],
	components: { OptionSelectField, Loading, Alert, TicketCategoryDialog },
	props: {
		modelValue: Object,
		dataCy: String,
		error: Boolean,
		serviceProviderOptionsOverride: Array, // CfObject<ticketType>
		dense: Boolean,
		canAddNew: { type: Boolean, default: true },
		disabled: Boolean,
	},
	data: () => ({
		model: null,
		serviceProvider: '',
		errorTitle: '',
		errorDetail: '',
		successTitle: '',
		successDetail: '',
	}),
	computed: {
		clientOptions() {
			if (this.serviceProviderOptionsOverride) return []
			return this.$store.state.selectedClient.fields.defaultAssignments.de.filter(option => option.sys?.contentType?.sys?.id === 'reduction')
		},
		serviceProviderOptions() {
			if (this.serviceProviderOptionsOverride) return this.serviceProviderOptionsOverride
			return this.$store.state.selectedServiceProvider?.fields?.reductions?.de?.length > 0 ? this.$store.state.selectedServiceProvider.fields.reductions.de : []
		},
	},
	watch: {
		modelValue(n) { this.model = n },
		model(n) { this.$emit('update:modelValue', n) },
	},
	methods: {
		addOptionStart() {
			if (this.userIsExternalOperator)
				return window.alert('Only the service provider and the home operator may add options.')
			this.$refs.ticketCategoryDialog.show()
		},
		async onTicketCategoryConfirm(ticketCategory) {
			// Dispatch success message to Application component
			this.applicationSuccess(this.$el, this.$t('text.SUCCESS'), this.$t('text.ticketCategoryCreated'))
			// Handle default assignment for operators
			if (this.userIsOperator) {
				try {
					const clientResponse = await this.$httpPost('/default-assignment', {
						clientId: this.$store.state.selectedClient.sys.id,
						optionId: ticketCategory.sys.id,
						defaultAssignment: true
					})
					if (clientResponse?.client?.fields?.defaultAssignments?.de) {
						this.$store.state.selectedClient.fields.defaultAssignments.de = clientResponse.client.fields.defaultAssignments.de
					}
				}
				catch (error) {
					console.error('Error setting default assignment:', error)
				}
			}
			this.model = ticketCategory
		},
		onTicketCategoryCancel() {
			// Dialog closed without saving
		},
	},
	mounted() {
		this.model = this.modelValue
		this.serviceProvider = this.$store.state.selectedServiceProvider
	},
}
</script>

<style scoped>
</style>

<style>
.dense .v-field__outline:before { border: 0 !important; }
.dense .v-field__input { padding-right: 0; }
.dense .v-combobox__menu-icon { margin-left: 0; }
</style>
